import { colors } from '@alixpartners/ui-components';
import { ActionItem } from 'BudgetTracker/SecondaryNav/SecondaryNav.styles';
import styled from 'styled-components';
import { grey200, grey400, white } from 'styles/colors';

export const CenteredContainer = styled.div`
	width: 80%;
	display: flex;
	justify-content: center;
	justify-items: center;
	margin-top: 5%;
	margin-left: auto;
	margin-right: auto;
`;

export const DashBoardDiv = styled.div`
	display: flex;
	justify-content: space-between;
	box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
	padding: 20px;
	margin: 20px;
	flex: 0.4;
	flex-direction: column;
`;

export const NavDiv = styled.div`
	box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
	padding: 20px;
	margin: 20px;
`;

export const SearchWrapper = styled(ActionItem)`
	display: flex;
	align-items: center;
	margin-top: 2%;
	margin-right: 2%;
	> div:first-child {
		width: 300px;
	}
`;

export const ChartWrapper = styled.div`
	display: flex;
	padding: 20px 20px 0 20px;
	margin: 20px 20px 20px 20px;
	flex: 0.4;
	justify-content: space-between;
`;

export const StyledGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(7, 1fr);
	width: 89%;
	border: 1px solid ${grey200};
	font-size: 14px;
	margin-left: auto;
	margin-right: auto;
`;
export const GridItem = styled.div`
	background-color: #f0f0f0;
	border: 1px solid ${grey200}; /* Border around each grid item */
	font-size: 14px;
	text-align: center;
	display: flex;
	justify-content: center; /* Center content horizontally */
	align-items: center;
	padding: 5px;
`;

export const PieChartData = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	font-size: 14px;
	margin-left: auto;
	margin-right:auto;
	background-color:${colors.chartDarkTeal}
	color:${white};
	border:1px solid ${grey400};
	padding : 5px;
`;

export const WaterfallWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 500px;
	margin-left: 5%;
`;

export const PieWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 500px;
`;
